import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Truck: "",
    Driver: "",
  },
};

const SliceWMSStockReport = createSlice({
  name: "SliceWMSStockReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_WMSStockReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_WMSStockReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_WMSStockReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_WMSStockReport_Init,
  Set_WMSStockReport_HeadObject_Set,
  Set_WMSStockReport_HeadObject_Init,
} = SliceWMSStockReport.actions;
export default SliceWMSStockReport.reducer;
